import './header.scss';

import {Link} from "react-router-dom";
import logo from "../../assets/img/logo.svg";

const Header = (props) => (
  <header>
    <Link className="link" to="/">
      <img src={logo} alt="" className="logo"/>
      <h1>Xerinola <span>| {props.section}</span></h1>
    </Link>
  </header>
)

export default Header